import { constants } from "../../misc/constants";
import Scenario1 from "./Scenario1";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario1Part7 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-1-1',
        chapterCinematic49: 'medsurg-cinematic-1-49',
        chapterCinematic50: 'medsurg-cinematic-1-50',
		chapterCinematic51: 'medsurg-cinematic-1-51',
        chapterCinematic52: 'medsurg-cinematic-1-52',
        chapterCinematic53: 'medsurg-cinematic-1-53',
		chapterCinematic76: 'medsurg-cinematic-1-76', // for testing - currently set to female 01
		chapterCinematic77: 'medsurg-cinematic-1-77', // for testing - currently set to female 02
		chapterCinematic74: 'medsurg-cinematic-1-74', // for testing - currently set to male 01
		chapterCinematic75: 'medsurg-cinematic-1-75', // for testing - currently set to male 02
	}

	constructor(scenario: Scenario1, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action31: boolean = false;
	private Action32: boolean = false;
	private Action33: boolean = false;
	private Action34: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;
	private CAbool: boolean = false;
	private PObool: boolean = false;
	
	private avatar1: boolean = false;
	private avatar2: boolean = false;
	private avatar3: boolean = false;
	private avatar4: boolean = false;

	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part7.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario1/video1' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario1/video10.mp4'];
	}

	public start() {
		const context = this;
		if(this.scenario.avatarIndx === 0) {
			this.avatar1 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 1) {
			this.avatar2 = true;
			this.avatar1 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 2) {
			this.avatar3 = true;
			this.avatar2 = false;
			this.avatar1 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 3) {
			this.avatar4 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar1 = false;
		}
		this.RememberDisplayed = false;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
			title: 'Vitals - On Admission'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
			list: '<li>Temperature: 98</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
			list: '<li>Pulse: 78</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
			list: '<li>Respirations: 16</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
			list: '<li>Blood Pressure: 142/86</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
			list: '<li>Oxygen Saturation: 97%</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
			title: 'Vitals - 16:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
			visit: context.scenario.visit1,
			lineBreak: true,
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesBasicID, {
			title: 'Patient Information',
			description: '<ul style=\"list-style-type:square\"><li>Alan Jones, a 47-year old black male, has been a paraplegic for the past 7 years. He was admitted with a diagnosis of Benign Prostatic Hypertrophy and underwent a Transurethral Resection of the Prostate, or TURP, surgical procedure. The perioperative portion of the surgery was uneventful and Mr. Jones was transferred to the medical surgical unit.</li><li>He has Continuous Bladder Irrigation (CBI) with Glycine infusing via a three-way catheter. He complains of pain, severe headache, and profuse sweating. The nurse must monitor his vitals and fluid output/drainage by closely observing the patient’s catheter.</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesBasicID, {
			title: 'Patient History',
			description: '<ul style=\"list-style-type:square\"><li>20 year history of smoking cigarettes</li><li>Type II diabetic</li><li>mild hypertension</li><li>African American</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesBasicID, {
			title: 'Active Medications',
			description: '<ul style=\"list-style-type:square\"><li>Clonidine patch 0.2, Terazosin 100 mg (for BP and prostate)</li><li>Glipizide (type II diabetes)</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesBasicID, {
			title: 'Providers Orders',
			description: '<ul style=\"list-style-type:square\"><li>Promethazine for nausea as needed</li><li>Acetaminophen #3 for pain as needed</li><li>Hydromorphone as needed for post-op pain</li><li>Patient is on a 3-way Foley catheter – 3000 cc saline or glycine bag should be used for irrigation and should be replaced when empty</li><li>Irrigate for clots</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesBasicID, {
			title: 'Dietary Restrictions',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesBasicID, {
			title: 'Other Observations',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesBasicID, {
			title: 'Post-Op Information',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});

		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
        this.scenario.displayModalPop(
			null,
            'Skipping to part 8',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
        context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            'You have a new patient to visit in room 3',
            () => {
				this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic49, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '3', '1', false, false);
				context.TalkCount = 3;
				context.ActionCount = 1;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.displayDebrief(2800, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
			title: 'Vitals - 18:30'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
			visit: context.scenario.visit2,
			lineBreak: true,
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.PatientRecordUI, {
            top: [
				{
					description: 'Name: Alan Jones'
				},
				{
					description: 'Room: #3'
				},
				{
					description: 'Age: 47'
				},
				{
					description: 'Sex: Male'
				}
			],
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).jonesBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).jonesNursesID),
			lab: [
				{
					title: 'Test Name',
					description1: 'BUN',
					description2: '<div style="color: red" aria-label="5 m g over d L. down"> 5 mg/dL <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="8 to 26">8 - 26</div>'
				},
				{
					title: 'Results',
					description1: 'Creatine',
					description2: '<div aria-label="0.7 m g over d L">0.7 mg/dL</div>', // 7 change to 9 for down arrow
					description3: '<div aria-label="0.7 to 1.2">0.7 - 1.2</div>'
				},
				{
					title: 'Normal Range',
					description1: 'Sodium',
					description2: '<div style="color: red" aria-label="135 m m o l over L. down"> 135 mmol/L <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="136 to 145">136 - 145</div>'
				},
				{
					description1: 'Potassium',
					description2: '<div aria-label="4.2 m m o l over L">4.2 mmol/L</div>',
					description3: '<div aria-label="3.5 to 5.1">3.5 - 5.1</div>'
				},
				{
					description1: 'Chloride',
					description2: '<div style="color: red" aria-label="127 m m o l over L. up"> 127 mmol/L <span style="float: right">&#129137;</span></div>',
					description3: '<div aria-label="98 to 107">98 - 107</div>'
				},
				{
					description1: 'Glucose',
					description2: '<div aria-label="92 m g over d L">92 mg/dL</div>',
					description3: '<div aria-label="74 to 106">74 - 106</div>'
				},
				{
					description1: 'HGB',
					description2: '<div aria-label="14 g over d L">14 g/dL</div>',
					description3: '<div aria-label="13.5 to 17.9">13.5 - 17.9</div>'
				},
				{
					description1: 'HCT',
					description2: '<div aria-label="42 g over d L">42 g/dL</div>',
					description3: '<div aria-label="41 to 54">41 - 54</div>'
				}
			],
			vitals: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).jonesVitalsID),
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			} 
		});

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario1).PrJonesID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Would you like something for the pain?',
					onClicked: () => {
						this.segment1TalkPills();
					},
					disable: () => this.Talk3
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'How are you feeling?',
			scenario: this,
			isTalks: true,
			extBottom: true,
			extText: "Not so good. I'm sweating like crazy, and I have a nasty headache.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Patient Assessment',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Headache',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Sweating',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 5,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 100,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'General',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Surgical Site',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Abdominal',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Head',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Chest',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic50, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic49, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			scenario: this,
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 7,
			extBottom: true,
			extText: "I'd say my pain is at a seven - it's pretty bad.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic51, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic49, () => {}, true);
		});
	}

	private segment1TalkPills() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Would you like something for the pain?',
			scenario: this,
			isTalks: true,
			extBottom: true,
			extText: "Yes, Thank you.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
					title: context.scenario.medicineAdministered,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.medicineAdministered)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					binaryq: true,
					talktext1: 'Medication Administered',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic52, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic49, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '98.4',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			scenario: this,
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>Temperature : 98.4</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '170px',
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '189/95',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>Blood Pressure : 189/95</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '270px',
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '90',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>Pulse : 90</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '370px',
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '23',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>Respirations : 23</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			scenario: this,
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '96% room air',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesVitalsID, {
					list: '<li>02 Sat Level : 96% room air</li>',
				})
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.updateScore(100);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment2PreloadUis();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action1 = true;
		};
		context.getFooterCounts();
	}

	private segment2PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Adjust Bed',
					onClicked: () => {
						this.segment2ActionBed();
					},
					disable: () => this.Action2
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 1
		context.getFooterCounts2();
	}

	private segment2ActionBed() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Adjust Bed',
			isTalks: true,
			onSubmit: () => {
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					binaryq: true,
					talktext1: ' ',
					talktext2: 'Adjust Bed',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Supine',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Semi-Fowlers',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'High Fowlers',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Trendelenburg',
							onClicked: () => {
							},
						}
					],
					setFailed: true,
					failedOnDone: () => {
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						this.scenario.displayModalPop(
							null,
							'That is the incorrect bed position for assessing the bladder. Try again.',
							() => {
								context.scenario.destroyAllUIInstances();
								context.segment2ActionBed();
							}
						);
					},
					passedOnDone: () => {
						context.scenario.updateScore(100);
						context.scenario.gameManager.environment.blurFadeOut();
						this.playVideoChapter(this.chapterIds.chapterCinematic53, () => {}, true);
						this.Action2 = true;
						this.ActionCount = this.OldActionCount - 1;
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						context.getFooterCounts2();
					}
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts2() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.Action2 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment3PreloadUis();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		};
	}

	private segment3PreloadUis() {
        var context = this;
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Assess Patient',
					onClicked: () => {
						this.segment3ActionAssess();
					},
					disable: () => this.Action3
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		context.ActionCount = 4
		context.getFooterCounts3();
	}

	private segment3ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'Bladder',
					onClicked: () => {
						context.segment1ActionBladder();
					},
					disable: () => this.Action31
				},
				{
					toppx: '150px',
					titletext: 'Catheter: Check Urine Output',
					onClicked: () => {
						context.segment1ActionUrine();
					},
					disable: () => this.Action32
				},
				{
					toppx: '250px',
					titletext: 'Catheter: Check Drainage Color',
					onClicked: () => {
						context.segment1ActionColor();
					},
					disable: () => this.Action33
				},
				{
					toppx: '350px',
					titletext: 'Catheter: Change Irrigation Bag',
					onClicked: () => {
						context.segment1ActionBag();
					},
					disable: () => this.Action34
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionBladder() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: "Bladder",
			isTalks: true,
			extTop: true,
			extImg: 'AssessingAbdominal',
			extText: 'Bladder feels soft with no abnormalities.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action31 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					binaryq: true,
					talktext1: 'Patient Observation',
					talktext2: 'Bladder',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Normal',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Mild Distension',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Moderate Distension',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Severe Distension',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionUrine() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: "Catheter: Check Urine Output",
			isTalks: true,
			extTop: true,
			extImg: 't6',
			extText: '500 ml',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action32 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Catheter',
					talktext2: 'Urine Output',
					talks: [
						{
							buttontop: '150px',
							buttontext: '1500 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: '500 ml',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: '100 ml',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: '0 ml',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionColor() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: "Catheter: Check Drainage Color",
			isTalks: true,
			extTop: true,
			extImg: 't6',
			extText: 'Dark red in color',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.CAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
						title: context.scenario.catheter,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.CAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.catheter)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action33 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 200,
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Drainage Color',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clear',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Pink',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Dark Red',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBag() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '370px',
			loadQuiz: true,
			titletext: "Catheter: Change Irrigation Bag",
			isTalks: true,
			scenario: this,
			extTop: true,
			extImg: 't7',
			extText: '1.5% Glycine Irrigation USP',
			onSubmit: () => {
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					binaryq: true,
					talktext1: 'Catheter',
					talktext2: 'Irrigation Bag',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Saline',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Glycine',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Water',
							onClicked: () => {
							},
						}
					],
					setFailed: true,
					failedOnDone: () => {
						context.segment2ActionFail();
					},
					passedOnDone: () => {
						if(this.CAbool === false) {
							this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
								title: context.scenario.catheter,
							}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
							this.CAbool = true;
						}
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).jonesNursesID, {
							header: 'Irrigation Bag',
							list: '<li>Glycine</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.catheter)
						context.scenario.updateScore(250);
						this.Action34 = true;
						this.ActionCount = this.OldActionCount - 1;
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
						context.checkIfSubMenu2();
					}
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts3() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.Action3 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.hideFooter();
			context.segment1Part5Debrief();
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		};
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action31 === true && this.Action32 === true && this.Action33 === true && this.Action34 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action3 = true;
		};
		context.getFooterCounts3();
	}

	private segment2ActionFail() {
		var context = this;
		this.scenario.gameManager.environment.blurFadeIn();
		this.scenario.displayModalPop(
			null,
            "Your patient has had an adverse event. Please report to the nurses’ station to speak with your charge nurse.",
            () => {
                context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.scenario.updateFooter('0', '0', true, true);
				context.scenario.hideFooter();
				context.segment2ActionChargeNurse();
            }
        );
	}

	private segment2ActionChargeNurse() {
		var context = this;
		//NEED FAIL ANIM, CHANGE CHAPTERCINEMATICS BELOW TO EACH PLAYER CHARACTER LOOP
		if(this.avatar1) {
			this.playVideoChapter(this.chapterIds.chapterCinematic76, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar2) {
			this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar3) {
			this.playVideoChapter(this.chapterIds.chapterCinematic74, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar4) {
			this.playVideoChapter(this.chapterIds.chapterCinematic75, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		}
		setTimeout(() => {
			context.segment2ActionChargeNurseNext();
		}, 1000);
	}

	private segment2ActionChargeNurseNext() {
		var context = this;
		//context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.showRemediation(
			'I would like to discuss Mr. Jones’ change in condition. You chose to replace Mr. Jones’ irrigation bag with water rather than glycine or saline. This has led to an adverse event. Please return to Room #3 and begin caring for your patient again.',
			'./assets/images/general/icons/npc-headshots/ChargeNurse.png',
			() => {
				context.scenario.gameManager.environment.blurFadeOut();
				localStorage.setItem('ignoreResumePopup', 'true');
				window.location.reload();
			}
		)
	}
}